module.exports = __webpack_public_path__ + "img/payment_card.873163a9.png";